// 校验规则列表（可扩展）
const rules = {
  EmptyArr(arr) {
    const flag = arr.length > 0
    return valid(arr, flag, '空数组')
  },

  StrLessThan30(str) {
    const regex = /^.{1,30}$/
    return valid(str, regex, '输入长度不能超过30个字')
  },
  StrLessThan20(str) {
    const regex = /^.{1,20}$/
    return valid(str, regex, '输入长度不能超过20个字')
  },
  StrLessThan16(str) {
    const regex = /^.{2,16}$/
    return valid(str, regex, '输入长度2-16个字符')
  },
  StrLessThan50(str) {
    const regex = /^.{1,50}$/
    return valid(str, regex, '输入长度不能超过50个字')
  },

  URL(url) {
    const regex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?"\\+&%$#=~_-]+))*$/
    return valid(url, regex, 'URL格式不正确')
  },

  LowerCase(str) {
    const regex = /^[a-z]+$/
    return valid(str, regex, '只能输入小写字母')
  },

  UpperCase(str) {
    const regex = /^[A-Z]+$/
    return valid(str, regex, '只能输入大写字母')
  },

  Alphabets(str) {
    const regex = /^[A-Za-z]+$/
    return valid(str, regex, '只能输入字母')
  },

  Email(email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return valid(email, regex, '邮箱地址格式不正确')
  },

  Mobile(mobile) {
    const regex = /^1\d{10}$/
    return valid(mobile, regex, '手机号格式不正确')
  },
  Mobile2(mobile) {
    const regex = /^1[3456789]\d{9}$/
    return valid(mobile, regex, '手机号格式不正确')
  },
  Phone(phone) {
    const regex = /^(0\d{2,3})?-?\d{7,8}$/
    return valid(phone, regex, '电话号码格式不正确')
  },

  Postcode(postcode) {
    const regex = /^[0-9][0-9]{5}$/
    return valid(postcode, regex, '邮编格式不正确')
  },

  Number(num) {
    const regex = /^\d+$/
    return valid(num, regex, '只能输入纯数字')
  },
  Number3(num) {
    const regex = /^\d{1,3}$/
    return valid(num, regex, '只能输入0-999之间的数字')
  },

  Fax(fax) {
    const regex = /^(\d{3,4}-)?\d{7,8}$/
    return valid(fax, regex, '传真格式不正确')
  },

  Int(num) {
    const regex = /^((0)|([1-9]\d*))$/
    return valid(num, regex, '只能输入非负整数')
  },

  IntPlus(num) {
    const regex = /^[1-9]\d*$/
    return valid(num, regex, '只能输入正整数')
  },

  Float1(num) {
    const regex = /^-?\d+(\.\d)?$/
    return valid(num, regex, '只能输入数字，最多一位小数')
  },

  Float2(num) {
    const regex = /^-?\d+(\.\d{1,2})?$/
    return valid(num, regex, '只能输入数字，最多两位小数')
  },

  Float3(num) {
    const regex = /^-?\d+(\.\d{1,3})?$/
    return valid(num, regex, '只能输入数字，最多三位小数')
  },

  FloatPlus3(num) {
    const regex = /^\d+(\.\d{1,3})?$/
    return valid(num, regex, '只能输入数字，最多三位小数')
  },

  Encode(code) {
    const regex = /^(_|-|[a-zA-Z0-9])+$/
    return valid(code, regex, '编码只能使用字母、数字、下划线、中划线')
  },

  Encode2(code) {
    const regex = /^[a-zA-Z0-9]+$/
    return valid(code, regex, '编码只能使用字母、数字')
  },

  Encode3(code) {
    const regex = /^(_|[a-zA-Z0-9])+$/
    return valid(code, regex, '编码只能使用字母、数字、下划线')
  },
  Encode4(code) {
    const regex = /^[a-zA-Z0-9]{4,20}$/
    return valid(code, regex, '只能使用字母、数字、1至20个字符')
  },
  Encode5(code) {
    const regex = /^[a-zA-Z0-9]{1,9}$/
    return valid(code, regex, '只能使用字母、数字、1至9个字符')
  },

  IdCard(code) {
    const regex = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    return valid(code, regex, '请输入正确的身份证号码')
  },

  USCC(code) {
    const regex = /^[0-9A-Z]{18}/
    return valid(code, regex, '请输入正确的社会信用号')
  },

  CarNum(code) {
    const regex = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/i
    return valid(code, regex, '请输入正确的车牌号')
  },

  CNandEN(code) {
    const regex = /^[a-zA-Z\u4e00-\u9fa5]+$/
    return valid(code, regex, '只能使用中文、英文')
  },

  PassWord(code) {
    const regex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W]{6,18}$/
    return valid(code, regex, '密码必须包含字母和数字，且在6-18位之间')
  },

  MobileOrPhone(val) {
    const result = /^1\d{10}$/.test(val) || /^(0\d{2,3})?-?\d{7,8}$/.test(val)
    return valid(result, null, '手机或电话号格式不正确')
  },

  CursomRouter(code) {
    const regex = /^\//
    return valid(code, regex, '路径前面必须要/')
  }
}


var idCardNoUtil = {
  /*省,直辖市代码表*/
  provinceAndCitys: {
    11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江",
    31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东",
    45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏",
    65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
  },

  /*每位加权因子*/
  powers: ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"],

  /*第18位校检码*/
  parityBit: ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"],

  /*性别*/
  genders: { male: "M", female: "F" },

  /*校验地址码*/
  checkAddressCode: function (addressCode) {
    var check = /^[1-9]\d{5}$/.test(addressCode);
    if (!check) return false;
    if (idCardNoUtil.provinceAndCitys[parseInt(addressCode.substring(0, 2))]) {
      return true;
    } else {
      return false;
    }
  },

  /*校验日期码*/
  checkBirthDayCode: function (birDayCode) {
    var check = /^[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(birDayCode);
    if (!check) return false;
    var yyyy = parseInt(birDayCode.substring(0, 4), 10);
    var mm = parseInt(birDayCode.substring(4, 6), 10);
    var dd = parseInt(birDayCode.substring(6), 10);
    var xdata = new Date(yyyy, mm - 1, dd);
    if (xdata > new Date()) {
      return false;//生日不能大于当前日期
    } else if ((xdata.getFullYear() == yyyy) && (xdata.getMonth() == mm - 1) && (xdata.getDate() == dd)) {
      return true;
    } else {
      return false;
    }
  },

  /*计算校检码*/
  getParityBit: function (idCardNo) {
    var id17 = idCardNo.substring(0, 17);
    /*加权 */
    var power = 0;
    for (var i = 0; i < 17; i++) {
      power += parseInt(id17.charAt(i), 10) * parseInt(idCardNoUtil.powers[i]);
    }
    /*取模*/
    var mod = power % 11;
    return idCardNoUtil.parityBit[mod];
  },

  /*验证校检码*/
  checkParityBit: function (idCardNo) {
    var parityBit = idCardNo.charAt(17).toUpperCase();
    if (idCardNoUtil.getParityBit(idCardNo) == parityBit) {
      return true;
    } else {
      return false;
    }
  },

  /*校验15位或18位的身份证号码*/
  checkIdCardNo: function (idCardNo) {
    //15位和18位身份证号码的基本校验
    var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
    if (!check) return false;
    //判断长度为15位或18位
    if (idCardNo.length == 15) {
      return idCardNoUtil.check15IdCardNo(idCardNo);
    } else if (idCardNo.length == 18) {
      return idCardNoUtil.check18IdCardNo(idCardNo);
    } else {
      return false;
    }
  },

  //校验15位的身份证号码
  check15IdCardNo: function (idCardNo) {
    //15位身份证号码的基本校验
    var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
    if (!check) return false;
    //校验地址码
    var addressCode = idCardNo.substring(0, 6);
    check = idCardNoUtil.checkAddressCode(addressCode);
    if (!check) return false;
    var birDayCode = '19' + idCardNo.substring(6, 12);
    //校验日期码
    check = idCardNoUtil.checkBirthDayCode(birDayCode);
    if (!check) return false;
    //验证校检码
    return idCardNoUtil.checkParityBit(idCardNo);
  },

  //校验18位的身份证号码
  check18IdCardNo: function (idCardNo) {
    //18位身份证号码的基本格式校验
    var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
    if (!check) return false;
    //校验地址码
    var addressCode = idCardNo.substring(0, 6);
    check = idCardNoUtil.checkAddressCode(addressCode);
    if (!check) return false;
    //校验日期码
    var birDayCode = idCardNo.substring(6, 14);
    check = idCardNoUtil.checkBirthDayCode(birDayCode);
    if (!check) return false;
    //验证校检码
    return idCardNoUtil.checkParityBit(idCardNo);
  },

  formateDateCN: function (day) {
    var yyyy = day.substring(0, 4);
    var mm = day.substring(4, 6);
    var dd = day.substring(6);
    return yyyy + '-' + mm + '-' + dd;
  },

  //获取信息
  getIdCardInfo: function (idCardNo) {
    var idCardInfo = {
      gender: "",  //性别
      birthday: "" // 出生日期(yyyy-mm-dd)
    };
    if (idCardNo.length == 15) {
      var aday = '19' + idCardNo.substring(6, 12);
      idCardInfo.birthday = idCardNoUtil.formateDateCN(aday);
      if (parseInt(idCardNo.charAt(14)) % 2 == 0) {
        idCardInfo.gender = idCardNoUtil.genders.female;
      } else {
        idCardInfo.gender = idCardNoUtil.genders.male;
      }
    } else if (idCardNo.length == 18) {
      var aday = idCardNo.substring(6, 14);
      idCardInfo.birthday = idCardNoUtil.formateDateCN(aday);
      if (parseInt(idCardNo.charAt(16)) % 2 == 0) {
        idCardInfo.gender = idCardNoUtil.genders.female;
      } else {
        idCardInfo.gender = idCardNoUtil.genders.male;
      }

    }
    return idCardInfo;
  },

  /*18位转15位*/
  getId15: function (idCardNo) {
    if (idCardNo.length == 15) {
      return idCardNo;
    } else if (idCardNo.length == 18) {
      return idCardNo.substring(0, 6) + idCardNo.substring(8, 17);
    } else {
      return null;
    }
  },

  /*15位转18位*/
  getId18: function (idCardNo) {
    if (idCardNo.length == 15) {
      var id17 = idCardNo.substring(0, 6) + '19' + idCardNo.substring(6);
      var parityBit = idCardNoUtil.getParityBit(id17);
      return id17 + parityBit;
    } else if (idCardNo.length == 18) {
      return idCardNo;
    } else {
      return null;
    }
  }
}

// val:String 要校验的值
// regex:RegExp 校验正则,不是正则时val作为result的值
// msg:String 校验不通过的错误信息
function valid(val, regex, msg) {
  return {
    result: regex instanceof RegExp ? regex.test(val) : !!val,
    errMsg: msg
  }
}

// required:Boolean 是否必填项，选填，默认"true"
// type:String/Function 校验类型，选填，
//     String时必须是上面rules中存在的函数名，
//     Function时只接收一个参数(输入值)，返回格式： {result:Boolean, errMsg:String}
// trigger:String 触发动作，选填，默认"blur"
// nullMsg:String 未输入的提示语，选填，required=true时有效
export function vxRule(required = true, type, trigger = 'blur', nullMsg = '该字段为必填项') {
  const rule = {
    required: !!required,
    trigger
  }

  let check = null
  if (typeof type === 'function') {
    check = type
    if (check) { // 存在规则时添加规则
        rule.validator = (r, v, c) => {
        check(v).then(({ result, errMsg }) => {
          if (required) {
            // 必填项: null,undefined,"","  " 都算无输入内容
            return (v == null || (v + '').trim() === '') ? c(new Error(nullMsg)) : result ? c() : c(new Error(errMsg))
          }
          // 选填项: null,undefined,"" 都算无输入内容，"  "会被校验
          return (v == null || (v + '') === '' || result) ? c() : c(new Error(errMsg))
        })
      }
    } else {
      rule.message = nullMsg
    }
  } else if (type === 'idNumber') {
    // 身份证校验
    rule.validator = (r, v, c) => {
      // const {
      //   result,
      //   errMsg
      // } = check(v)
      const result = idCardNoUtil.checkIdCardNo(v)
      const errMsg = '请输入正确的身份证信息'
      if (required) {
        // 必填项: null,undefined,"","  " 都算无输入内容
        return (v == null || (v + '').trim() === '') ? c(new Error(nullMsg)) : result ? c() : c(new Error(errMsg))
      }
      // 选填项: null,undefined,"" 都算无输入内容，"  "会被校验
      return (v == null || (v + '') === '' || result) ? c() : c(new Error(errMsg))
    }

  } else {
    check = type ? rules[type + ''] : null
    if (check) { // 存在规则时添加规则
      rule.validator = (r, v, c) => {
        const {
          result,
          errMsg
        } = check(v)
        if (required) {
          // 必填项: null,undefined,"","  " 都算无输入内容
          return (v == null || (v + '').trim() === '') ? c(new Error(nullMsg)) : result ? c() : c(new Error(errMsg))
        }
        // 选填项: null,undefined,"" 都算无输入内容，"  "会被校验
        return (v == null || (v + '') === '' || result) ? c() : c(new Error(errMsg))
      }
    } else {
      rule.message = nullMsg
    }
  }

  return [rule]
}